import { BaseService } from "./base";

export interface PeriodosLetivosRequest {
  nome: string;
  startAt: string;
  endAt: string;
}

export interface PeriodosLetivosResponse {
  id: string;
  nome: string;
  startAt: string;
  endAt: string;
}

class PeriodosLetivosService extends BaseService {
  constructor() {
    super("periodos-letivos");
  }

  create(item: PeriodosLetivosRequest): Promise<void> {
    return this.post("", item);
  }

  update(id: string, item: PeriodosLetivosRequest): Promise<void> {
    return this.put(id, item);
  }

  getAll(): Promise<PeriodosLetivosResponse[]> {
    return this.get("");
  }

  read(id: string): Promise<PeriodosLetivosResponse> {
    return this.get(id);
  }

  getCurrentPeriod(): Promise<PeriodosLetivosResponse> {
    return this.get("atual");
  }

  remove(id: string): Promise<void> {
    return this.delete(id);
  }
}

export default new PeriodosLetivosService();
